import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { VaultAuthService } from '../services/vault-auth.service';

/**
 * Requires a vault session, restoring one from the refresh cookie if this is a fresh page load.
 *
 * The restore attempt is what makes the in-memory access token workable: after a reload there is
 * no token in the tab, only the httpOnly cookie, so the guard has to exchange it before deciding
 * whether the user is signed in. Redirecting straight to sign-in without trying would log
 * everyone out on every refresh.
 */
export const vaultAuthGuard: CanActivateFn = async (_route, state) => {
  const auth = inject(VaultAuthService);
  const router = inject(Router);

  if (auth.isSignedIn()) return true;

  if (await auth.restore()) return true;

  return router.createUrlTree(['/vault/sign-in'], {
    queryParams: { returnUrl: state.url },
  });
};
